import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * @returns {Promise<object>}
 */
function fetchCartJson() {
  const raw =
    typeof Theme !== 'undefined' && Theme.routes?.cart_url
      ? String(Theme.routes.cart_url)
      : '/cart';
  const path = raw.split('?')[0];
  const url = path.endsWith('.js') ? path : `${path.replace(/\/?$/, '')}.js`;
  return fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
}

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#logCartOnDrawerOpen);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#logCartOnDrawerOpen);
  }

  #logCartOnDrawerOpen = () => {
    fetchCartJson()
      .then((cart) => {
        console.log('[cart-drawer] cart', cart);
      })
      .catch((err) => {
        console.warn('[cart-drawer] cart fetch failed', err);
      });
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      
      // Wait for cart to finish updating before scrolling
      const scrollToTop = () => {
        const cartItemsContainer = this.querySelector('.cart-drawer__items');
        if (cartItemsContainer) {
          cartItemsContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      };
      
      // Listen for section rendered event (cart has finished updating)
      const onSectionRendered = () => {
        document.removeEventListener('section:rendered', onSectionRendered);
        requestAnimationFrame(scrollToTop);
      };
      
      document.addEventListener('section:rendered', onSectionRendered);
      
      // Fallback timeout in case section:rendered doesn't fire
      setTimeout(() => {
        document.removeEventListener('section:rendered', onSectionRendered);
        scrollToTop();
      }, 500);
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
